<template>
    <div class="container">
        <div class="row justify-content-center align-items-center vh-100">
            <div class="col-3">
                <h1 class="fw-bold text-primary title">404</h1>
            </div>
            <div class="col-4 align-self-center">
                <h3 class="my-0">
                    Page Not Found
                </h3>
                <p>We couldn't find the page you're looking for!</p>
                <router-link to="/" class="btn btn-sm btn-primary">Home</router-link>
            </div>
        </div>
    </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];

export default {
    name: "not-found",
    created() {
        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
}
</script>

<style scoped>
    .title {
        font-size: 150px;
    }
</style>